<template>
  <div class="w-full" v-if="isCardActiveLocal">
    <div class="flex mb-2" style="justify-content: space-between;">
      <div class="flex" style="align-items: center;">
        <h4 style="margin-bottom: 0;">Select A Grade</h4>
      </div>
      <vx-input-group class="input-group-with-input-for-filtering ml-4" style="">
        <template slot="prepend">
          <div class="prepend-text ">
            <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current h-5 w-5"></feather-icon></span>
          </div>
        </template>

        <vs-input class="dashboard-filter-input" placeholder="Search here..." v-model="gradesFilterText"/>
      </vx-input-group>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
        <div v-if="!loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col mb-3" v-for="(grade, index) in grades" :key="index" style="padding-left: 0; padding-right: 0;">
            <data-card  :smallText="true" class="mx-2" type="grades" @handleClick="selectedGrade(grade)" :title="grade.grade" :myTime="grade.timeSpentMaxStudent" :avgTime="grade.timeSpentAvgClassroom" :radialData="[grade.scoreMaxStudent, grade.scoreAvgClassroom]" :highestAvg="true"/>
          </div>          
        </div>
        <div v-if="loadingDataCards" class="vx-row data-card-container">
          <div class="vx-col w-full mb-3" style="padding-left: 0; padding-right: 0;">
            <data-card-skeleton :count="4"/>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsTime" @filterDropdownChanged="filterDropdownChangedStudentGraphTimeSpent" :series="timeSpentSeries" :title="'Time Spent'" :filterList="listOfgradessForDropdown"/>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <line-chart :isLoading="loadingChartsScore"  @filterDropdownChanged="filterDropdownChangedStudentGraphScore" :series="scoreSeries" :title="'Score'" :filterList="listOfgradessForDropdown"/>
      </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import DataCard from './DataCard.vue'
import CustomSkeleton from './CustomSkeleton.vue'
import DataCardSkeleton from './DataCardSkeleton.vue'
import LineChart from './LineChart.vue';
export default {
  name: "Grades",
  components: {
    vSelect,
    DataCard,
    CustomSkeleton,
    DataCardSkeleton,
    LineChart
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      loadingDetails:true,
      loadingDataCards:true,
      loadingChartsTime:true,
      loadingChartsScore:true,
      grades: [],
      originalgradess: [],
      gradesFilterText: "",
      listOfgradessForDropdown: [],
      scoreSeries:[],
      timeSpentSeries:[],
      userDetailsObject:{},
    };
  },
  watch: {
    isCardActive: function(val) {
      var self = this;
      if(val){
        self.getgradess();
        localStorage.setItem("Teacher_Position",JSON.stringify({}));
        localStorage.setItem("Active_Card","0");
      }
      if(!val){
        self.timeSpentSeries = [];
        self.scoreSeries = [];
      }
    },
    gradesFilterText: function(val) {
      var self = this;
      if(val) {
        self.grades = self.originalgradess.filter(function(x) { return x.grade.toLowerCase().includes(val.toLowerCase()) });
      } else {
        self.grades = self.originalgradess;
      }
    }
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) { }
    },
  },
  methods: {
    getgradess() {
      var self = this;

      self.loadingDetails = true;
      self.loadingDataCards = true;

      var onSuccess = function(response) {
        self.grades = response.data;
        self.listOfgradessForDropdown = self.grades.map((item) => {return { label: item.grade, value: item.gradeId }});

        self.originalgradess = self.grades;
      };

      var onFinally = function() {
        self.loadingDataCards = false;
        self.loadingChartsTime = false;
        self.loadingChartsScore = false;
      };
      self.$ajaxGet(self, `PrincipalDashboard/GetGradeList`, onSuccess, onFinally);
    },
    selectedGrade(grades){
      this.$emit('selectedGrade', grades);
    },
    filterDropdownChangedStudentGraphTimeSpent(gradesName,gradesId,selectedDate) {
      var self = this;
      this.loadingChartsTime = true;
      var onSuccess = response =>{
        self.timeSpentSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.avaragesList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.timeSpentAvaragesList
          }
        ];
      }
      var onFinally = response =>{
        self.loadingChartsTime = false;
      }
    
      self.$ajaxGet(self, `PrincipalDashboard/TimeSpentGraphHighest?month=${selectedDate.monthIndex}&year=${selectedDate.year}&gradeId=${gradesId}` , onSuccess, onFinally);
    },
    filterDropdownChangedStudentGraphScore(gradesName,gradesId,selectedDate) {
      var self = this;
      this.loadingChartsScore = true;
      var onSuccess = response =>{
        self.scoreSeries = [
          {
            name: "Single Student Avg.",
            data: response.data.scoreList,
          },
          {
            name: "Combined Student Avg.",
            data: response.data.scoreListAvg,
          },
        ];
      }
    
      var onFinally = response =>{
        self.loadingChartsScore = false;
      }
      self.$ajaxGet(self, `PrincipalDashboard/HigestScore?month=${selectedDate.monthIndex}&year=${selectedDate.year}&gradeId=${gradesId}` , onSuccess, onFinally);
    },
  },
  created() {
  },
  mounted() {
    var self = this;
    self.$emit("updateBreadcrumbs", "add", { text: "home", clickFunction: "backToGrades", icon: "HomeIcon" });
    self.getgradess();
  }
};
</script>
